"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2870],{

/***/ 52870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ResultsBlock_ResultsBlock; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./theme/mixins/padding.ts
var padding = __webpack_require__(54986);
;// CONCATENATED MODULE: ./blocks/ResultsBlock/ResultsBlock.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          border-top: 1px solid ",
        ";\n        "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          border-top: 1px solid ",
        "; ;\n        "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          border-bottom: 1px solid ",
        ";\n        "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          border-bottom: 1px solid ",
        "; ;\n        "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-top: 1px solid ",
        ";\n      "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-top: 1px solid rgba(0, 0, 0, 0.2); ;\n      "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          border-bottom: 1px solid ",
        ";\n        "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          border-bottom: 1px solid rgba(0, 0, 0, 0.2); ;\n        "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n",
        ";\n  ",
        ";\n\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n  background: ",
        ";\n\n  ",
        ";\n\n  ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  p {\n    color: ",
        ";\n    font-size: 1.5rem;\n    font-family: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}




const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a95aec2a-0"
})(_templateObject9(), (0,padding/* blockPadV */.zr)({
    pt: "sm",
    pb: "sm"
}), (0,padding/* blockPadH */.XA)(), (param)=>{
    let { theme  } = param;
    return theme.themeColors.bg;
}, (param)=>{
    let { borderTop , borderTopColor , theme  } = param;
    return borderTop && (borderTopColor ? (0,styled_components_browser_esm/* css */.iv)(_templateObject(), borderTopColor) : (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), theme.themeColors.fg));
}, (param)=>{
    let { borderBottom , borderBottomColor , theme  } = param;
    return borderBottom && (borderBottomColor ? (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), borderBottomColor) : (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), theme.themeColors.fg));
}, (param)=>{
    let { borderTop , borderTopColor , borderBottom , borderBottomColor , theme  } = param;
    return theme.mq.md(_templateObject8(), borderTop && (borderTopColor ? (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), borderTopColor) : (0,styled_components_browser_esm/* css */.iv)(_templateObject5())), borderBottom && (borderBottomColor ? (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), borderBottomColor) : (0,styled_components_browser_esm/* css */.iv)(_templateObject7())));
});
const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a95aec2a-1"
})(_templateObject10(), (0,padding/* blockW */.g5)("lg"), (param)=>{
    let { theme  } = param;
    return theme.themeColorOpacities.fg50;
}, (param)=>{
    let { theme  } = param;
    return theme.fontStacks.sans[0];
});
const ResultsBlock = (param)=>{
    let { title , text , borderTop , borderTopColor , borderBottom , borderBottomColor  } = param;
    const boolBorderTop = borderTop;
    const boolBorderBottom = borderBottom;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        borderTop: boolBorderTop,
        borderTopColor: "".concat(borderTopColor),
        borderBottom: boolBorderBottom,
        borderBottomColor: "".concat(borderBottomColor),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: text
                })
            ]
        })
    });
};
/* harmony default export */ var ResultsBlock_ResultsBlock = (ResultsBlock);

;// CONCATENATED MODULE: ./blocks/ResultsBlock/index.ts



/***/ })

}]);